import React, { useState, useEffect } from "react";

import { CloseOutlined } from "@ant-design/icons";
import {
  Modal,
  // Switch,
} from "antd";
import moment from "moment";
import { toast } from "react-toastify";

import Loading from "../../../../Common/Loading";
import NoResults from "../../../../Common/NoResults";
import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import CoaPreviewModal from "../Preview/CoaPreviewModal";
import { buildSingleCoaPreviewFilePaths } from "../ReportSpecs/helper";
import FileCard from "./FileCard";

import { getReportHistory } from "../../../../../actions/reports";

import pumpkin from "../../../../../assets/images/environment/pumpkin.gif";
import "./ReportHistory.css";

export default function ReportHistory({
  sampleId,
  sampleType,
  receivedDate,
  setShowReportHistory,
  reportHistory: propReportHistory, // Optional prop from reports/ API response
  report,
}) {
  const [reportHistory, setReportHistory] = useState(propReportHistory || []);
  const [loadingHistory, setLoadingHistory] = useState(!propReportHistory);
  const [showPartialOnly, setShowPartialOnly] = useState(true); // Default to "partial"
  const [previewFile, setPreviewFile] = useState(null);

  /**
   * Handle toggle switch change
   */
  // eslint-disable-next-line
  const handleShowPartialOnly = () => {
    setShowPartialOnly(!showPartialOnly);
  };

  /**
   * Fetch report history on component mount and when toggle changes
   * Always fetches from API to get latest data, prop is only used as initial/fallback data
   */
  useEffect(() => {
    // Always fetch from API to get latest data
    const fetchReportHistory = async () => {
      setLoadingHistory(true);
      try {
        // Format received_date to YYYY-MM-DD format for API
        const formattedDate = receivedDate
          ? moment(new Date(receivedDate)).format("YYYY-MM-DD")
          : "";

        // Determine action based on toggle: "partial" when true, "all_report" when false
        const action = showPartialOnly ? "partial" : "all_report";

        const response = await getReportHistory({
          sample_id: sampleId,
          sample_type: sampleType,
          received_date: formattedDate,
          action,
        });

        if (response.success) {
          setReportHistory(response.reports || []);
        } else {
          toast.error(response.message || "Failed to load report history");
          setReportHistory([]);
        }
      } catch (error) {
        toast.error("Failed to load report history");
        setReportHistory([]);
      } finally {
        setLoadingHistory(false);
      }
    };

    fetchReportHistory();
  }, [sampleId, sampleType, receivedDate, showPartialOnly]);

  const messageStyle = {
    fontSize: "16px",
    color: "rgb(117, 138, 185)",
    fontFamily: "Roboto",
  };

  const previewFilePaths = buildSingleCoaPreviewFilePaths(previewFile?.s3_report_path);
  const previewReport = report || {
    sample_id: sampleId,
    sample_type: sampleType,
    received_date: receivedDate,
  };

  const handlePreviewFile = (file) => {
    setPreviewFile(file);
  };

  const handleClosePreview = () => {
    setPreviewFile(null);
  };

  return (
    <Modal
      open
      closable={false}
      centered
      footer={null}
      onCancel={() => setShowReportHistory(false)}
      wrapClassName="ProductReportHistoryModal"
      className="ProductReportHistoryModal"
      width="743px"
    >
      <div className="ProductReportHistoryModal__Header">
        <div className="ProductReportHistoryModal__Header__Title">
          <span>Partial Report History</span>
          {/* <span className="prod-report-history-partial-switch">
            <Switch
              size="small"
              checked={showPartialOnly}
              onChange={handleShowPartialOnly}
              loading={loadingHistory}
            />
            <span>Partial</span>
          </span> */}
        </div>
        <CloseOutlined
          className="ProductReportHistoryModal__CloseIcon"
          aria-label="Close"
          onClick={() => setShowReportHistory(false)}
        />
      </div>
      <div className="ProductReportHistoryModal__Body">
        <div className="prod-report-history-container">
          <div className="prod-report-history-table">
            {loadingHistory && (
              <div className="prod-report-history-loading">
                <Loading />
              </div>
            )}
            {!loadingHistory && reportHistory.length > 0 && (
              <StyledScrollbar>
                {reportHistory.map((file, index) => (
                  <FileCard
                    key={index}
                    file={file}
                    onPreview={handlePreviewFile}
                  />
                ))}
              </StyledScrollbar>
            )}
            {!loadingHistory && reportHistory.length === 0 && (
              <NoResults messageStyle={messageStyle} message="No reports found" image={pumpkin} />
            )}
          </div>
        </div>
      </div>
      {previewFilePaths && (
        <CoaPreviewModal
          filePaths={previewFilePaths}
          report={previewReport}
          handleCloseForPreview={handleClosePreview}
          zIndex={1100}
        />
      )}
    </Modal>
  );
}
